<!-- <app-rectangle-simmer
  class="mt-4"
  *ngIf="shimmerStatus.Interviews"
></app-rectangle-simmer> -->
<section
  class="multi-slider top-rated-user-sect bg-white"
  *ngIf="
    !shimmerStatus.Interviews &&
    content === gridConfig.grid_content.interviewsTitle &&
    popularVideos.length > 0
  "
>
  <div
    class="content-slider container"
    [ngClass]="{ 'content-padding': isContent === true }"
  >
    <div
      class="content-box"
      *ngIf="
        isContent === true &&
        content === gridConfig.grid_content.interviewsTitle
      "
    >
      <div class="">
        <h1 class="mb-3 slider-heading">
          {{ content | translate }}
        </h1>
        <!-- <p class="orange-link">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
          volutpat est in magna lacinia, at efficitur justo laoreet.
        </p> -->
        <hr />
        <a
          *ngIf="url === 'top-rated-contents'"
          [routerLink]="['/list/top-rated-contents']"
          class="orange-link d-flex align-items-center"
        >
          {{ "HOME.VIEW_ALL" | translate }}
          <span class="mdi mdi-chevron-right font-18 ml-1"></span>
        </a>
        <a
          *ngIf="url === 'recommended-list'"
          [routerLink]="['/recommended-list']"
          class="orange-link d-flex align-items-center"
        >
          {{ "HOME.VIEW_ALL" | translate }}
          <span class="mdi mdi-chevron-right font-18 ml-1"></span>
        </a>
        <a
          *ngIf="url === 'popular-list'"
          [routerLink]="['/list/popular-list']"
          class="orange-link d-flex align-items-center"
        >
          {{ "HOME.VIEW_ALL" | translate }}
          <span class="mdi mdi-chevron-right font-18 ml-1"></span>
        </a>
      </div>
    </div>
    <div class="best-movies-sect">
      <div id="slider-top">
        <owl-carousel-o [options]="toprated">
          <ng-container *ngFor="let watch of popularVideos; let i = index">
            <ng-template carouselSlide [id]="watch.public_id">
              <div class="series-box">
                <app-grid [data]="watch" [gridType]="'portrait'"></app-grid>
              </div>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </div>
    </div>
  </div>
</section>

<app-rectangle-simmer
  *ngIf="shimmerStatus.trendingContent"
></app-rectangle-simmer>

<section
  class="multi-slider top-rated-user-sect gray-bg"
  *ngIf="
    !shimmerStatus.trendingContent &&
    content === gridConfig.grid_content.trendingContentsTitle &&
    trendingContent.length > 0
  "
>
  <div
    class="content-slider"
    [ngClass]="{ 'content-padding': isContent === true }"
  >
    <div
      class="content-box"
      *ngIf="
        isContent === true &&
        content === gridConfig.grid_content.trendingContentsTitle
      "
    >
      <div class="">
        <h1 class="mb-3 slider-heading">
          {{ content }}
        </h1>
        <hr />
        <a
          *ngIf="content === gridConfig.grid_content.trendingContentsTitle"
          [routerLink]="['/list/popular-trending-contents']"
          class="orange-link d-flex align-items-center"
        >
          {{ "HOME.VIEW_ALL" | translate }}
          <span class="mdi mdi-chevron-right font-18 ml-1"></span>
        </a>
      </div>
    </div>
    <div class="">
      <div id="slider-top">
        <owl-carousel-o [options]="toprated">
          <ng-container *ngFor="let watch of trendingContent; let i = index">
            <ng-template carouselSlide [id]="watch.public_id">
              <div class="series-box">
                <app-grid [data]="watch" [gridType]="'portrait'"></app-grid>
              </div>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </div>
    </div>
  </div>
</section>
<section
  class="series-slider multi-slider"
  *ngIf="
    shimmerStatus.continueWatching === false &&
    content === 'continueWatchingData' &&
    content !== 'recommendedData' &&
    continueWatchingData.length > 0
  "
  (mouseenter)="playOff()"
>
  <div class="">
    <div id="popular" class="section-head">
      <h2>{{ "HOME.Continue_Watching" | translate }}</h2>
      <a
        *ngIf="continueWatchingData.length > 1"
        (click)="deleteContinueWatching('clear_all')"
        class="view-all-link cursor-pointer"
      >
        {{ "HOME.CLEAR_ALL" | translate }}
      </a>
    </div>
    <div class="slider" id="slider-top">
      <owl-carousel-o [options]="upcomingShow">
        <ng-container *ngFor="let continue of continueWatchingData">
          <ng-template carouselSlide [id]="continue?.public_id">
            <div class="series-box">
              <app-grid
                [data]="continue"
                [gridType]="'landscape'"
                [watchingStatus]="true"
                [status]="'Continue_Watching'"
              ></app-grid>
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </div>
  </div>
</section>
<div
  class="home-page"
  *ngIf="content === 'recommendedData' && content !== 'continueWatchingData'"
>
  <div *ngIf="recommendedData?.content?.length > 0">
    <section class="pt-3">
      <div class="container">
        <div class="">
          <div class="section-head" (mouseenter)="playOff()">
            <h2 class="mr-2">
              {{ "HOME.RECOMMENDED_FOR_YOU" | translate }}
            </h2>
            <a
              *ngIf="recommendedData.content.length > 7"
              href="javascript:void(0)"
              class="text-primary"
              routerLink="/{{ url }}"
            >
              {{ "HOME.VIEW_ALL" | translate }}
            </a>
          </div>
          <div id="slider-top">
            <owl-carousel-o [options]="recommended">
              <ng-container
                *ngFor="
                  let recommended of recommendedData.content;
                  let i = index
                "
              >
                <ng-template carouselSlide [id]="recommended.public_id">
                  <div class="series-box">
                    <app-grid
                      [data]="recommended"
                      [gridType]="'portrait'"
                    ></app-grid>
                  </div>
                </ng-template>
              </ng-container>
            </owl-carousel-o>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
